import { PcApiResponse } from '@/api/pc-api/types';
import { BizTargetType } from '@/constants/bizTargetType';
import { BizType } from '@/constants/bizType';
import { Role } from '@/constants/role';
import { api } from '@/utils/api';

export type AuthInfoIdValidate = {
  bizTargetType: BizTargetType;
  bizType: BizType;
  role: Role;
  targetId?: number;
  targetType?: string;
  dealerName?: string;
  dealerId?: string;
  partnerName?: string;
  partnerId?: string;
  newAuthInfoId?: string;
  needAppReg?: boolean;
};

export const getAuthInfoIdValidate = (authInfoId: string) => {
  return api<PcApiResponse<AuthInfoIdValidate>>('get', `/pc-api/v1/auth/auth-info-id/validate`, {
    authInfoId
  });
};
